import React from 'react';
import { Shelf } from '../../../../../lib/modelBuilder/entities/Shelf';
import { useTranslation } from 'react-i18next';
import {
  StyledTabularDataRow,
  StyledTabularTitle,
  StyledTabularValue,
} from '../../../../../components/styles/StyledTabular';
import { Drawer } from '../../../../../lib/modelBuilder/pieces/Drawer';
import { CustomPiece } from '../../../../../lib/modelBuilder/pieces/CustomPiece';
import {
  PaneMaterial,
  DrawerHandleType,
  Position,
  PositionAngle,
} from '../../../../../lib/modelBuilder/constants';
import { DrawerHandle } from '../../../../../lib/modelBuilder/pieces/DrawerHandle';
// import styled from 'styled-components';

interface Props {
  shelf: Shelf;
  materialName: (material: PaneMaterial) => string;
}

const DrawersDescription = ({ shelf, materialName }: Props) => {
  const { t } = useTranslation();

  const getDrawerHandleType = (type: DrawerHandleType): string => {
    switch (type) {
      case DrawerHandleType.Knop:
        return t('Knop');
      case DrawerHandleType.Button:
        return t('Button');
      case DrawerHandleType.Slat:
        return t('Slat');
      case DrawerHandleType.Eco:
        return t('Eco');
      case DrawerHandleType.EcoPlus:
        return t('Eco+');
      default:
        return 'None';
    }
  };

  const getDrawerColorName = (drawer: CustomPiece<Drawer>) =>
    drawer.drawerHandlesType === DrawerHandleType.Eco ||
    drawer.drawerHandlesType === DrawerHandleType.EcoPlus
      ? t('Natural')
      : drawer.color.name;

  const getDrawerHandleColor = (drawer: CustomPiece<Drawer>) => {
    if (
      !drawer.handle ||
      (drawer.drawerHandlesType !== DrawerHandleType.Knop &&
        drawer.drawerHandlesType !== DrawerHandleType.Button)
    )
      return '';

    const handle =
      (drawer.handle as CustomPiece<DrawerHandle>[]).length === 2
        ? drawer.getDrawerHandle(PositionAngle.FrontLeft)
        : drawer.getDrawerHandle(Position.Front);

    return ` ${handle?.color.name}`;
  };

  const drawersInfo = () =>
    shelf.drawers
      .sort(
        (a: CustomPiece<Drawer>, b: CustomPiece<Drawer>) =>
          (b.position as number) - (a.position as number),
      )
      .map(
        (drawer: CustomPiece<Drawer>) =>
          `${drawer.height / 10} cm ${materialName(
            drawer.material,
          )} ${getDrawerColorName(drawer)}`,
      )
      .join(' / ');

  const drawersHandles = () =>
    shelf.drawers
      .sort(
        (a: CustomPiece<Drawer>, b: CustomPiece<Drawer>) =>
          (b.position as number) - (a.position as number),
      )
      .map(
        (drawer: CustomPiece<Drawer>) =>
          getDrawerHandleType(drawer.drawerHandlesType) +
          getDrawerHandleColor(drawer),
      )
      .join(' / ');

  if (!shelf.drawers || shelf.drawers.length === 0) return null;

  return (
    <>
      <StyledTabularDataRow>
        <StyledTabularTitle>{t('Drawers')}</StyledTabularTitle>
        <StyledTabularValue>{drawersInfo()}</StyledTabularValue>
      </StyledTabularDataRow>
      <StyledTabularDataRow>
        <StyledTabularTitle>{t('Handles')}</StyledTabularTitle>
        <StyledTabularValue>{drawersHandles()}</StyledTabularValue>
      </StyledTabularDataRow>
    </>
  );
};

export default DrawersDescription;
